import { useContext, useEffect, useMemo, useState } from 'react'
import { useParams, Navigate, useNavigate } from "react-router-dom"
import { Box } from '@mui/material'

import { AppContext } from '/providers/app-context'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/template-notify-passes'
import NotifyPassesMenu from '/components/passes/notify-passes-menu'
import TemplateSelector from '/components/templates/template-selector'
import TemplatePassesTable from '/components/passes/template-passes-table'
import { getCurrentTemplateId } from '/utils/current-template'

const NotifyPasses = () => {
  const navigate = useNavigate()
  const { templateId } = useParams()
  const { loadingTemplates, templates } = useContext(AppContext)
  const [selectedPass, setSelectedPass] = useState(null)
  const [selectedPasses, setSelectedPasses] = useState({ type: 'loaded', count: 0, mode: 'live', passes: [] })

  const template = useMemo(() => templates.filter(t => t.template_id === templateId)[0], [templates, templateId])
  const heading = useMemo(() => template ? `${template.name} ${template.archived ? " [archived]" : ""}` : "", [template])

  // See the matching Manage Passes route: a remembered template needs a
  // concrete URL before the shared pass table can fetch its data.
  useEffect(() => {
    if (templateId || loadingTemplates) return

    const currentTemplateId = getCurrentTemplateId()
    const currentTemplate = templates.find(item =>
      String(item.template_id) === String(currentTemplateId) && !item.archived
    )

    if (currentTemplate) navigate(`/templates/${currentTemplate.template_id}/notify-passes`, { replace: true })
  }, [loadingTemplates, navigate, templateId, templates])

  if (!loadingTemplates && !template && templateId) return <Navigate to="/templates" replace />

  const selectTemplate = selectedTemplateId => {
    setSelectedPass(null)
    setSelectedPasses({ type: 'loaded', count: 0, mode: 'live', passes: [] })
    navigate(selectedTemplateId ? `/templates/${selectedTemplateId}/notify-passes` : '/notify-passes')
  }

  if (!templateId) return (
    <PageWrapper title="Notify Passes" HelpText={HelpText} heading="Notify Passes">
      <Box sx={{ p: 3 }}>
        <TemplateSelector templateId={templateId} onChange={selectTemplate} />
      </Box>
    </PageWrapper>
  )

  return (
    <PageWrapper title={template ? `Notify Passes (${template.name})` : 'Notify Passes'} HelpText={HelpText} heading={heading} selectedTemplate={template} menu={<NotifyPassesMenu template={template} selectedPass={selectedPass} selectedPasses={selectedPasses} />}>
      <TemplatePassesTable
        templateId={templateId}
        onSelectTemplate={selectTemplate}
        onSelectedPassChange={setSelectedPass}
        onSelectedPassesChange={setSelectedPasses}
        onPassIdClick={pass => navigate(`/templates/${templateId}/notify-passes/${pass.pass_id}/history`, { state: { pass } })}
        onRowDoubleClick={pass => navigate(`/templates/${templateId}/notify-passes/${pass.pass_id}/history`, { state: { pass } })}
      />
    </PageWrapper>
  )
}

export default NotifyPasses
